import router from '@/router/index'
import store from '@/store/index'
import { mergeRoutes, resetTokenAndClearUser } from '@/utils'

//防止重复添加动态路由
let hasMenus = false;
// 拦截登录，session验证
router.beforeEach((to, from, next) => {
    if(sessionStorage.getItem("token")){
      if(to.path === '/login'){

        next();
      }else{
        if(hasMenus){
          next();
        }else{
          try {
            const menus = JSON.parse(sessionStorage.getItem("menus"));
            const routes = mergeRoutes(menus);
            router.options.routes = router.options.routes.concat(routes);
			router.addRoutes(router.options.routes);
            hasMenus = true
            // 刷新页面 要保留当前页面的query
            let qry = { ...to.query };
            next({ path: to.path, query: qry })
        } catch (error) {
            resetTokenAndClearUser()
            next(`/login?redirect=${to.path}`)
        }
        }
      }
    }else{
      hasMenus = false
      sessionStorage.clear();
      if(to.path === '/login'){
        next();
      }else{
        next(`/login?redirect=${to.path}`)
      }
    }
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});



// WEBPACK FOOTER //
// ./src/api/premission.js